import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { salesAPI } from '../api';

// ─────────────────────────────────────────────────────────────────────────────
// Экран клиента: где мой заказ.
//
// Открывается по ссылке из QR или по короткому коду, который клиенту дали при
// оформлении. Логина здесь нет и быть не может — заказчик не сотрудник завода.
//
// Ни имени, ни телефона, ни суммы на экране НЕТ. Ссылку пересылают дальше,
// чем предполагал тот, кто её получил: в переписку, в чат снабжения, в группу.
// Всё, что можно узнать по такой ссылке, — какой товар и на каком он шаге.
//
// Обновляется опросом раз в 15 секунд: вкладку держат открытой, пока грузят
// машину, и человек должен видеть движение, не трогая экран.
// ─────────────────────────────────────────────────────────────────────────────

const POLL_MS = 15000;

// ─── Язык ────────────────────────────────────────────────────────────────────
//
// Внутренний интерфейс завода всегда русский, и словарь оттуда убран
// намеренно: он заполнялся частично, и экран выходил лоскутным. Здесь случай
// другой — это НЕ интерфейс сотрудника. Читает его заказчик, для которого
// русский может быть вторым языком, а строк на всей странице три десятка, и
// список закрыт: он не растёт с каждой новой кнопкой в программе.
//
// Поэтому словарь лежит рядом со страницей, а не в i18n/: там он завтра
// снова начнёт отставать от кода, здесь — нет. Ключ, как и принято в проекте,
// русский текст.
const UZ = {
  'LamTech': 'LamTech',
  'Отслеживание заказа': 'Буюртмани кузатиш',
  'Где мой заказ': 'Буюртмам қаерда',
  'Введите код заказа — его выдали при оформлении.':
    'Буюртма кодини киритинг — уни расмийлаштиришда берганмиз.',
  'Показать': 'Кўрсатиш',
  'Заказ': 'Буюртма',
  'Код': 'Код',
  'Готовность': 'Тайёрлик',
  'Срок сдачи': 'Топшириш муддати',
  'ПОЗИЦИИ ЗАКАЗА': 'БУЮРТМА ТАРКИБИ',
  'шт': 'дона',
  'Загрузка...': 'Юкланмоқда...',
  'Заказ с таким кодом не найден': 'Бундай кодли буюртма топилмади',
  'Не удалось связаться с заводом': 'Завод билан боғланиб бўлмади',
  'Ввести другой код': 'Бошқа код киритиш',
  'Добавить на главный экран': 'Асосий экранга қўшиш',
  'Как установить на телефон': 'Телефонга қандай ўрнатиш',
  'Chrome: меню ⋮ → «Установить приложение»':
    'Chrome: меню ⋮ → «Установить приложение»',
  'Firefox: меню ⋮ → «Установить»': 'Firefox: меню ⋮ → «Установить»',
  'iPhone, Safari: «Поделиться» → «На экран Домой»':
    'iPhone, Safari: «Поделиться» → «На экран Домой»',
  'Если открыли из камеры или мессенджера — сначала откройте ссылку в браузере.':
    'Агар камерадан ёки мессенжердан очган бўлсангиз — аввал ҳаволани браузерда очинг.',
  'Обновлено': 'Янгиланди',
  'обновляется автоматически': 'ўзи янгиланиб туради',
  'Мои заказы': 'Менинг буюртмаларим',
  'Готово к погрузке': 'Юклашга тайёр',
  'паллет': 'паллета',
  'листов': 'лист',
  'Можно забирать': 'Олиб кетиш мумкин',
  'КАК ШЁЛ ЗАКАЗ': 'БУЮРТМА ҚАНДАЙ БОРДИ',
  'Принят': 'Қабул қилинди',
  'Начали изготовление': 'Ишлаб чиқариш бошланди',
  'Последний лист': 'Охирги лист',
  'Позвонить': 'Қўнғироқ қилиш',
  'Вопросы по заказу': 'Буюртма бўйича саволлар',
  'Сообщим, когда будет готово': 'Тайёр бўлганда хабар берамиз',
  'Подписаться в Telegram': 'Telegram’да обуна бўлиш',
  'Не нужно держать эту страницу открытой — завод напишет сам.':
    'Бу саҳифани очиқ ушлаб туриш шарт эмас — завод ўзи хабар беради.',
  // Шаги
  'В очереди': 'Навбатда',
  'Изготовление': 'Ишлаб чиқариш',
  'Готов': 'Тайёр',
  'Отгружен': 'Жўнатилди',
  'Заказ принят': 'Буюртма қабул қилинди',
  'В очереди на производство': 'Ишлаб чиқариш навбатида',
  'Изготавливается': 'Ишлаб чиқарилмоқда',
  'Готов к отгрузке': 'Жўнатишга тайёр',
  'Заказ отменён': 'Буюртма бекор қилинди',
  // Пояснения к шагам
  'Заказ у нас. Скоро он встанет в производственный план.':
    'Буюртма бизда. Тез орада ишлаб чиқариш режасига киритилади.',
  'Заказ в плане цеха и ждёт своей очереди на пресс.':
    'Буюртма цех режасида, пресс навбатини кутмоқда.',
  'Цех делает заказ. Счётчик ниже показывает готовые листы.':
    'Цех буюртмани бажармоқда. Қуйидаги ҳисоблагич тайёр листларни кўрсатади.',
  'Заказ изготовлен. О времени отгрузки договоритесь с менеджером.':
    'Буюртма тайёрланди. Жўнатиш вақтини менежер билан келишинг.',
  'Заказ готов, и отгрузка разрешена — можно приезжать.':
    'Буюртма тайёр ва жўнатишга рухсат берилган — келишингиз мумкин.',
  'Заказ отгружен. Спасибо за работу с нами.':
    'Буюртма жўнатилди. Ҳамкорлик учун раҳмат.',
  'Заказ отменён. Если это ошибка — свяжитесь с вашим менеджером.':
    'Буюртма бекор қилинди. Агар бу хато бўлса — менежерингизга мурожаат қилинг.',
};

const getLang = () => {
  try { return localStorage.getItem('track_lang') === 'uz' ? 'uz' : 'ru'; }
  catch (e) { return 'ru'; }
};

// Нет перевода — отдаём русский ключ. Ничего не теряется, и новая строка не
// ломает страницу до того, как её переведут.
const makeTr = (lang) => (s) => (lang === 'uz' && UZ[s]) || s;

const STAGES = [
  { key: 'accepted',   icon: '📝', label: 'Принят' },
  { key: 'queue',      icon: '⏳', label: 'В очереди' },
  { key: 'production', icon: '🏭', label: 'Изготовление' },
  { key: 'ready',      icon: '📦', label: 'Готов' },
  { key: 'shipped',    icon: '🚚', label: 'Отгружен' },
];

// Что написать под крупной строкой состояния. Клиент читает экран вместо
// звонка менеджеру — значит на нём должен быть ответ, а не только слово.
const STAGE_HINT = {
  accepted:   'Заказ у нас. Скоро он встанет в производственный план.',
  queue:      'Заказ в плане цеха и ждёт своей очереди на пресс.',
  production: 'Цех делает заказ. Счётчик ниже показывает готовые листы.',
  // «Изготовлен» и «можно забирать» — разные вещи. Отгрузку разрешает
  // менеджер отдельно: бывает не оплачено, бывает долг, бывает, что товар
  // обещан другому. Пообещать «лежит на складе, приезжайте» без этого
  // разрешения — значит отправить человека с машиной в пустую поездку.
  ready:      'Заказ изготовлен. О времени отгрузки договоритесь с менеджером.',
  shipped:    'Заказ отгружен. Спасибо за работу с нами.',
  cancelled:  'Заказ отменён. Если это ошибка — свяжитесь с вашим менеджером.',
};

const box = {
  background: 'var(--card)', border: '1px solid var(--border)',
  borderRadius: 'var(--radius)', padding: 18,
};

// ─── Заказы, которые открывали с этого телефона ──────────────────────────────
//
// Клиент — мебельная фабрика, и заказов у неё одновременно несколько. Ссылка
// же одна на заказ: чтобы посмотреть второй, надо искать другое письмо.
//
// Список лежит В ТЕЛЕФОНЕ, а не на сервере. Так и должно быть: связать заказы
// в один список на сервере — значит завести учётную запись клиента и хранить,
// кто чем интересовался. Здесь этого нет: браузер помнит свои коды, и никто
// больше их вместе не видит.
const SAVED_KEY = 'track_orders';

const readSaved = () => {
  try {
    const v = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]');
    return Array.isArray(v) ? v : [];
  } catch (e) { return []; }
};

const remember = (order) => {
  try {
    const rows = readSaved().filter(r => r.code !== order.public_code);
    rows.unshift({
      code:   order.public_code,
      number: order.order_number,
      stage:  order.stage,
      label:  order.stage_label,
      at:     Date.now(),
    });
    localStorage.setItem(SAVED_KEY, JSON.stringify(rows.slice(0, 12)));
  } catch (e) { /* приватный режим — просто не запомним */ }
};

// ─── Ввод кода: ссылку теряют чаще, чем бумажку ──────────────────────────────
function CodeForm({ tr }) {
  const [code, setCode] = useState('');
  const navigate = useNavigate();

  const go = (e) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (c) navigate(`/track/${c}`);
  };

  return (
    <form onSubmit={go} style={{ ...box, textAlign: 'center' }}>
      <div style={{ color: 'var(--text)', fontSize: 17, fontWeight: 700, marginBottom: 6 }}>
        {tr('Где мой заказ')}
      </div>
      <div style={{ color: 'var(--muted)', fontSize: 13.5, marginBottom: 18, lineHeight: 1.5 }}>
        {tr('Введите код заказа — его выдали при оформлении.')}
      </div>
      <input
        value={code}
        onChange={e => setCode(e.target.value.toUpperCase())}
        placeholder="K7M2QX"
        autoFocus
        maxLength={8}
        style={{
          width: '100%', background: 'var(--input)', border: '1px solid var(--border)',
          borderRadius: 10, color: 'var(--text)', fontSize: 26, fontWeight: 700,
          letterSpacing: 6, textAlign: 'center', padding: '14px 10px',
          fontFamily: 'inherit', outline: 'none',
        }}
      />
      <button type="submit" className="touch-btn" style={{
        width: '100%', marginTop: 14, background: 'var(--accent)', border: 'none',
        borderRadius: 10, color: '#fff', fontSize: 15.5, fontWeight: 700,
        padding: '13px 0', fontFamily: 'inherit',
      }}>
        {tr('Показать')}
      </button>
    </form>
  );
}

function SavedList({ tr, exclude }) {
  const rows = readSaved().filter(r => r.code !== exclude);
  const navigate = useNavigate();
  if (!rows.length) return null;

  return (
    <div style={{ ...box, marginTop: 12 }}>
      <div style={{ color: 'var(--muted)', fontSize: 11.5, fontWeight: 700,
                    letterSpacing: 1, marginBottom: 10 }}>
        {tr('Мои заказы').toUpperCase()}
      </div>
      {rows.map(r => (
        <div
          key={r.code}
          onClick={() => navigate(`/track/${r.code}`)}
          className="touch-btn"
          style={{
            background: 'var(--bg)', borderRadius: 10, padding: '10px 13px',
            marginBottom: 7, display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', gap: 10,
          }}>
          <div>
            <div style={{ color: 'var(--text)', fontSize: 13.5, fontWeight: 600 }}>
              {r.number}
            </div>
            <div style={{ color: 'var(--dim)', fontSize: 12, marginTop: 2 }}>
              {tr(r.label || '')}
            </div>
          </div>
          <span style={{ color: 'var(--accent)', fontSize: 13, fontWeight: 700,
                         letterSpacing: 1.5 }}>
            {r.code}
          </span>
        </div>
      ))}
    </div>
  );
}

// ─── Пять шагов ──────────────────────────────────────────────────────────────
function Stepper({ index, tr }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 4 }}>
      {STAGES.map((s, i) => {
        const done = i < index;
        const now  = i === index;
        const color = done ? 'var(--success)' : now ? 'var(--accent)' : 'var(--border)';
        return (
          <div key={s.key} style={{ flex: 1, textAlign: 'center', position: 'relative' }}>
            {/* Линия между кружками. Рисуем ДО кружка и только слева, иначе
                у последнего шага останется висеть хвост в пустоту. */}
            {i > 0 && (
              <div style={{
                position: 'absolute', top: 17, right: '50%', width: '100%', height: 2,
                background: i <= index ? 'var(--success)' : 'var(--border)',
              }} />
            )}
            <div style={{
              position: 'relative', width: 36, height: 36, margin: '0 auto',
              borderRadius: '50%', background: now ? 'var(--accent)' : 'var(--card)',
              border: `2px solid ${color}`, display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: 15,
              boxShadow: now ? '0 0 0 6px var(--accent-weak)' : 'none',
            }}>
              {done ? '✓' : s.icon}
            </div>
            <div style={{
              marginTop: 7, fontSize: 10.5, lineHeight: 1.25,
              color: now ? 'var(--text)' : done ? 'var(--muted)' : 'var(--dim)',
              fontWeight: now ? 700 : 500,
            }}>
              {tr(s.label)}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function TimeRow({ label, value }) {
  if (!value) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10,
                  fontSize: 13, marginBottom: 7 }}>
      <span style={{ color: 'var(--muted)' }}>{label}</span>
      <span style={{ color: 'var(--text)', fontWeight: 600, whiteSpace: 'nowrap' }}>
        {new Date(value).toLocaleString('ru-RU', {
          day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
      </span>
    </div>
  );
}

export default function TrackingPage() {
  const { trackingCode } = useParams();
  const [lang, setLang]       = useState(getLang);
  const [order, setOrder]     = useState(null);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(!!trackingCode);
  const [updated, setUpdated] = useState('');
  // Предложение установить: телефон покажет его сам, но только если страницу
  // открыли не из уже установленного ярлыка.
  const [install, setInstall] = useState(null);

  const tr = makeTr(lang);

  // Показывали ли уже заказ. Ref, а не состояние: значение читает таймер,
  // заведённый один раз, и пересобирать его на каждый ответ незачем.
  const shown = useRef(false);

  const load = useCallback(async () => {
    if (!trackingCode) return;
    try {
      const { data } = await salesAPI.trackOrder(trackingCode);
      shown.current = true;
      setOrder(data);
      remember(data);
      setError(null);
      setUpdated(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
    } catch (e) {
      // Сеть моргнула — держим на экране то, что уже показано: пустой экран
      // вместо статуса читается как «заказ пропал».
      if (!shown.current) setError(e?.response?.status === 404
        ? 'Заказ с таким кодом не найден'
        : 'Не удалось связаться с заводом');
    } finally {
      setLoading(false);
    }
  }, [trackingCode]);

  useEffect(() => {
    shown.current = false;
    load();
    const id = setInterval(load, POLL_MS);
    return () => clearInterval(id);
  }, [load]);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setInstall(e); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  const switchLang = (code) => {
    try { localStorage.setItem('track_lang', code); } catch (e) {}
    setLang(code);
  };

  const cancelled = order && order.stage === 'cancelled';
  const idx = order ? order.stage_index : -1;
  const canPickup = order && order.stage === 'ready' && order.can_pickup;
  const hint = canPickup
    ? 'Заказ готов, и отгрузка разрешена — можно приезжать.'
    : (order && STAGE_HINT[order.stage]) || '';
  const pallets = order?.pallets;
  const contact = order?.contact;

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      padding: '20px 14px 34px', display: 'flex', justifyContent: 'center',
    }}>
      <div style={{ width: '100%', maxWidth: 520 }}>

        <div style={{ position: 'relative', textAlign: 'center', marginBottom: 18 }}>
          <div style={{ fontSize: 26 }}>🏭</div>
          <div style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700, marginTop: 4 }}>
            LamTech
          </div>
          <div style={{ color: 'var(--dim)', fontSize: 12.5, marginTop: 2 }}>
            {tr('Отслеживание заказа')}
          </div>
          {/* Заказчик — не сотрудник завода, и русский для него может быть
              вторым языком. Переключатель маленький: тем, кому он не нужен,
              он не мешает. */}
          <div style={{ position: 'absolute', top: 0, right: 0, display: 'flex', gap: 4 }}>
            {['ru', 'uz'].map(c => (
              <button key={c} onClick={() => switchLang(c)} className="touch-btn" style={{
                background: lang === c ? 'var(--accent-weak)' : 'none',
                border: `1px solid ${lang === c ? 'var(--accent)' : 'var(--border)'}`,
                borderRadius: 6, color: lang === c ? 'var(--accent)' : 'var(--dim)',
                fontSize: 11.5, fontWeight: 700, padding: '3px 8px', fontFamily: 'inherit',
              }}>
                {c.toUpperCase()}
              </button>
            ))}
          </div>
        </div>

        {!trackingCode && (
          <>
            <CodeForm tr={tr} />
            <SavedList tr={tr} />
          </>
        )}

        {loading && (
          <div style={{ ...box, textAlign: 'center', color: 'var(--muted)' }}>
            {tr('Загрузка...')}
          </div>
        )}

        {error && (
          <div style={{ ...box, textAlign: 'center' }}>
            <div style={{ fontSize: 30, marginBottom: 8 }}>🔍</div>
            <div style={{ color: 'var(--danger)', fontSize: 15, fontWeight: 600 }}>
              {tr(error)}
            </div>
            <button onClick={() => window.location.assign('/track')} className="touch-btn" style={{
              marginTop: 16, background: 'none', border: '1px solid var(--border)',
              borderRadius: 8, color: 'var(--muted)', padding: '9px 18px',
              fontSize: 13.5, fontFamily: 'inherit',
            }}>
              {tr('Ввести другой код')}
            </button>
          </div>
        )}

        {order && (
          <>
            {/* Номер и код — единственное, чем заказ назван. Ни клиента, ни
                менеджера здесь нет намеренно. */}
            <div style={{ ...box, marginBottom: 12, display: 'flex',
                          alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
              <div>
                <div style={{ color: 'var(--dim)', fontSize: 11.5 }}>{tr('Заказ')}</div>
                <div style={{ color: 'var(--text)', fontSize: 17, fontWeight: 700 }}>
                  {order.order_number}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ color: 'var(--dim)', fontSize: 11.5 }}>{tr('Код')}</div>
                <div style={{ color: 'var(--accent)', fontSize: 17, fontWeight: 700,
                              letterSpacing: 2 }}>
                  {order.public_code}
                </div>
              </div>
            </div>

            <div style={{ ...box, marginBottom: 12 }}>
              {!cancelled && <Stepper index={idx} tr={tr} />}

              <div style={{
                textAlign: 'center', marginTop: cancelled ? 0 : 18,
                paddingTop: cancelled ? 0 : 16,
                borderTop: cancelled ? 'none' : '1px solid var(--border)',
              }}>
                <div style={{
                  fontSize: 19, fontWeight: 700,
                  color: cancelled ? 'var(--danger)' : 'var(--text)',
                }}>
                  {cancelled ? '❌ ' : ''}{tr(order.stage_label)}
                </div>

                {/* Разрешение на отгрузку — отдельная строка, а не оттенок
                    текста: именно по ней человек решает, ехать ему или нет. */}
                {canPickup && (
                  <div style={{
                    display: 'inline-block', marginTop: 10, padding: '5px 14px',
                    borderRadius: 20, background: 'var(--success)', color: '#fff',
                    fontSize: 13, fontWeight: 700,
                  }}>
                    ✅ {tr('Можно забирать')}
                  </div>
                )}

                <div style={{ color: 'var(--muted)', fontSize: 13, marginTop: 8, lineHeight: 1.5 }}>
                  {tr(hint)}
                </div>
              </div>

              {!cancelled && (
                <div style={{ marginTop: 18 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between',
                                marginBottom: 6, fontSize: 12.5 }}>
                    <span style={{ color: 'var(--muted)' }}>{tr('Готовность')}</span>
                    <span style={{ color: 'var(--text)', fontWeight: 700 }}>{order.progress}%</span>
                  </div>
                  <div style={{ background: 'var(--input)', borderRadius: 5, height: 9 }}>
                    <div style={{
                      width: `${order.progress}%`, height: 9, borderRadius: 5,
                      background: order.progress >= 100 ? 'var(--success)' : 'var(--accent)',
                      transition: 'width .6s ease',
                    }} />
                  </div>
                </div>
              )}

              {order.deadline && (
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between',
                              fontSize: 13 }}>
                  <span style={{ color: 'var(--muted)' }}>{tr('Срок сдачи')}</span>
                  <span style={{ color: 'var(--text)', fontWeight: 600 }}>
                    {new Date(order.deadline).toLocaleDateString('ru-RU')}
                  </span>
                </div>
              )}
            </div>

            {/* Сколько паллет — вопрос практический: по нему клиент решает,
                какую машину присылать. Пока паллет нет, строки тоже нет:
                «0 паллет» ничего не сообщает. */}
            {pallets && pallets.count > 0 && (
              <div style={{ ...box, marginBottom: 12, display: 'flex',
                            alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 22 }}>🧱</span>
                <div>
                  <div style={{ color: 'var(--text)', fontSize: 14.5, fontWeight: 700 }}>
                    {pallets.count} {tr('паллет')} · {pallets.quantity} {tr('листов')}
                  </div>
                  <div style={{ color: 'var(--dim)', fontSize: 12, marginTop: 2 }}>
                    {tr('Готово к погрузке')}
                  </div>
                </div>
              </div>
            )}

            <div style={{ ...box }}>
              <div style={{ color: 'var(--muted)', fontSize: 11.5, fontWeight: 700,
                            letterSpacing: 1, marginBottom: 12 }}>
                {tr('ПОЗИЦИИ ЗАКАЗА')}
              </div>
              {order.items.map((item, i) => {
                const pct = item.quantity > 0
                  ? Math.min(100, Math.round(item.quantity_done * 100 / item.quantity))
                  : 0;
                return (
                  <div key={i} style={{
                    background: 'var(--bg)', borderRadius: 10, padding: '11px 13px',
                    marginBottom: 8,
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                      <div style={{ color: 'var(--text)', fontSize: 13.5, fontWeight: 600 }}>
                        {item.product_name}
                      </div>
                      <div style={{ color: 'var(--muted)', fontSize: 13, whiteSpace: 'nowrap' }}>
                        {item.quantity_done} / {item.quantity} {tr('шт')}
                      </div>
                    </div>
                    {item.texture_name && (
                      <div style={{ color: 'var(--dim)', fontSize: 12, marginTop: 2 }}>
                        {item.texture_name}
                      </div>
                    )}
                    <div style={{ background: 'var(--card)', borderRadius: 4, height: 4, marginTop: 8 }}>
                      <div style={{
                        width: `${pct}%`, height: 4, borderRadius: 4,
                        background: pct >= 100 ? 'var(--success)' : 'var(--accent)',
                      }} />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Когда заказ приняли и когда по нему работал цех. Отвечает на
                «вы вообще начинали?» фактом, ничего не обещая на будущее:
                обещанный и не сделанный срок хуже, чем отсутствие обещания. */}
            {order.timeline?.first_sheet && (
              <div style={{ ...box, marginTop: 12 }}>
                <div style={{ color: 'var(--muted)', fontSize: 11.5, fontWeight: 700,
                              letterSpacing: 1, marginBottom: 12 }}>
                  {tr('КАК ШЁЛ ЗАКАЗ')}
                </div>
                <TimeRow label={tr('Принят')}              value={order.timeline.accepted} />
                <TimeRow label={tr('Начали изготовление')} value={order.timeline.first_sheet} />
                <TimeRow label={tr('Последний лист')}      value={order.timeline.last_sheet} />
              </div>
            )}

            {/* Раньше с этого экрана некуда было пойти с вопросом: статус
                есть, спросить не у кого. Номер общий, заводской, а не личный
                номер менеджера: люди меняются, а ссылка у клиента остаётся. */}
            {contact?.phone && (
              <div style={{ ...box, marginTop: 12, display: 'flex',
                            alignItems: 'center', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ color: 'var(--muted)', fontSize: 12 }}>
                    {tr('Вопросы по заказу')}
                  </div>
                  <div style={{ color: 'var(--text)', fontSize: 15, fontWeight: 700,
                                marginTop: 2 }}>
                    {contact.phone}
                  </div>
                  {contact.address && (
                    <div style={{ color: 'var(--dim)', fontSize: 12, marginTop: 3 }}>
                      {contact.city ? `${contact.city}, ` : ''}{contact.address}
                    </div>
                  )}
                </div>
                <a href={`tel:${contact.phone.replace(/[^\d+]/g, '')}`}
                   className="touch-btn"
                   style={{
                     background: 'var(--accent)', color: '#fff', borderRadius: 8,
                     padding: '10px 16px', fontSize: 13.5, fontWeight: 600,
                     textDecoration: 'none', whiteSpace: 'nowrap',
                   }}>
                  📞 {tr('Позвонить')}
                </a>
              </div>
            )}

            {/* Подписка на уведомления. Экран отвечает на «где заказ», но
                спросить должен человек: открыть, обновить, подождать. А хочет
                он обратного — забыть про заказ и получить сообщение, когда тот
                готов. Кнопки нет, пока бот не настроен: нажатие, за которым
                ничего не происходит, хуже отсутствия кнопки. */}
            {order.telegram && (
              <a href={order.telegram} target="_blank" rel="noopener noreferrer"
                 className="touch-btn"
                 style={{
                   display: 'flex', alignItems: 'center', gap: 12, marginTop: 12,
                   ...box, textDecoration: 'none',
                 }}>
                <span style={{
                  width: 40, height: 40, borderRadius: '50%', background: '#229ED9',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 19, flexShrink: 0,
                }}>✈️</span>
                <span style={{ flex: 1 }}>
                  <span style={{ display: 'block', color: 'var(--text)', fontSize: 14,
                                 fontWeight: 700 }}>
                    {tr('Сообщим, когда будет готово')}
                  </span>
                  <span style={{ display: 'block', color: 'var(--dim)', fontSize: 12,
                                 marginTop: 2, lineHeight: 1.4 }}>
                    {tr('Не нужно держать эту страницу открытой — завод напишет сам.')}
                  </span>
                </span>
                <span style={{ color: '#229ED9', fontSize: 13, fontWeight: 700,
                               whiteSpace: 'nowrap' }}>
                  {tr('Подписаться в Telegram')} →
                </span>
              </a>
            )}

            <SavedList tr={tr} exclude={order.public_code} />

            {/* Установка. Кнопку показывает не всякий браузер: событие
                beforeinstallprompt есть только у Chromium, а Firefox и Safari
                ставят приложение из своего меню и никакого события не шлют.
                Поэтому там, где кнопки нет, пишем, куда нажать руками —
                иначе человек ищет установку в меню и не находит. */}
            {install ? (
              <button
                onClick={() => { install.prompt(); setInstall(null); }}
                className="touch-btn"
                style={{
                  width: '100%', marginTop: 14, background: 'none',
                  border: '1px dashed var(--border)', borderRadius: 10,
                  color: 'var(--muted)', padding: '12px 0', fontSize: 13.5,
                  fontFamily: 'inherit',
                }}>
                📲 {tr('Добавить на главный экран')}
              </button>
            ) : (
              <details style={{
                marginTop: 14, background: 'var(--card)',
                border: '1px dashed var(--border)', borderRadius: 10,
                padding: '11px 14px',
              }}>
                <summary style={{ color: 'var(--muted)', fontSize: 13,
                                  cursor: 'pointer', listStyle: 'none' }}>
                  📲 {tr('Как установить на телефон')}
                </summary>
                <div style={{ color: 'var(--dim)', fontSize: 12.5, lineHeight: 1.7,
                              marginTop: 8 }}>
                  {tr('Chrome: меню ⋮ → «Установить приложение»')}<br />
                  {tr('Firefox: меню ⋮ → «Установить»')}<br />
                  {tr('iPhone, Safari: «Поделиться» → «На экран Домой»')}<br />
                  <span style={{ display: 'block', marginTop: 6 }}>
                    {tr('Если открыли из камеры или мессенджера — сначала откройте ссылку в браузере.')}
                  </span>
                </div>
              </details>
            )}

            <div style={{ textAlign: 'center', color: 'var(--dim)', fontSize: 11.5,
                          marginTop: 16 }}>
              {tr('Обновлено')} {updated} · {tr('обновляется автоматически')}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
